import { applyMiddleware, createStore, combineReducers } from "redux";
import thunk from "redux-thunk";
import promise from "redux-promise";
import signalr from "./Reducers/signalrReducer";
import menu from "./Reducers/menuReducer";
import main from "./Reducers/mainReducer";
import segurado from "./Reducers/seguradoReducer";

const reducers = combineReducers({
  signalr,
  menu,
  main,
  segurado
});

const createStoreWithMiddleware = applyMiddleware(
  thunk,
  promise
)(createStore);
const store = createStoreWithMiddleware(reducers);

export default store;
